import { Log, LogLevel } from "@/services/logging/types";
import store from "@/store";
import Api from "@/services/api";

export async function logError(log: any) {
    console.log(log);
    await store.dispatch("logger/addLog", { message: log, level: LogLevel.error } as Log);
}

export async function logInformation(log: string) {
    console.log(log);
    await store.dispatch("logger/addLog", { message: log, level: LogLevel.information } as Log);
}

export async function logDebug(log: string) {
    console.log(log);
    await store.dispatch("logger/addLog", { message: log, level: LogLevel.debug } as Log);
}

export async function shipLogs(logs: Log[]): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/logs`, logs).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
